<div align="right" class="notif-dialog-icon">
  <button mat-icon-button mat-dialog-close>
    <mat-icon color="red">close</mat-icon>
  </button>
</div>
<div class="notif-content">
  <p>Les rôles de l'utilisateur '{{data.username}}({{data.email}})' ont été modifiés, veuillez lui demander de se
    reconnecter.</p>
</div>